import { render } from "./RecuperarContrasena.vue?vue&type=template&id=70259588&scoped=true"
import script from "./RecuperarContrasena.vue?vue&type=script&lang=js"
export * from "./RecuperarContrasena.vue?vue&type=script&lang=js"

import "./RecuperarContrasena.vue?vue&type=style&index=0&id=70259588&lang=scss&scoped=true"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70259588"]])

export default __exports__